import { ajax } from 'rxjs/ajax';

export default class StartSalesBannerModel {
    name: string;

    phoneNumber: string;

    constructor({ name, phoneNumber }) {
        this.name = name;
        this.phoneNumber = phoneNumber;
    }

    static post(params) {
        return ajax.post(
            '/api/v1/account/sales-start',
            new StartSalesBannerModel({ ...params })
        );
    }
}
